import { WalletTxnType } from "@screens/Wallet/v2/utils";
import * as actionTypes from "./actionTypes";

const initialState = {
  timeFilters: [],
  transactionFilters: [],
  currentTimeFilter: {
    label: "Today",
    key: "TODAY",
  },
  currentTransactionFilter: {},
  walletSummary: null,
  error: null,
  isLoading: false,
  walletTxnType: WalletTxnType.ALL,
  walletTransactions: {
    transactions: [],
    summary: null,
    hasMore: true,
    nextOffset: 0,
  },
  transactionType: null,
  modalApi: null,
  modalData: null,
  modalLoading: false,
};
export const actions = {
  getWalletSummary: () => ({ type: actionTypes.GET_WALLET_SUMMARY_REQ }),
  getWalletSummarySuccess: (payload) => ({
    type: actionTypes.GET_WALLET_SUMMARY_SUCCESS,
    payload,
  }),
  getWalletSummaryFail: (error) => ({
    type: actionTypes.GET_WALLET_SUMMARY_FAIL,
    error,
  }),
  setTimeFilter: (filter) => ({
    type: actionTypes.SET_TIME_FILTER,
    filter,
  }),
  setTransactionFilter: (filter) => ({
    type: actionTypes.SET_TRANSACTION_FILTER,
    filter,
  }),
  setLoading: (value) => ({ type: actionTypes.SET_WALLET_LOADING, value }),
  setWalletTxnType: (value) => ({
    type: actionTypes.SET_WALLET_TXN_TYPE,
    value,
  }),
  getWalletMetaData: () => ({ type: actionTypes.GET_WALLET_METADATA_REQ }),
  getWalletMetaDataSuccess: (payload) => ({
    type: actionTypes.GET_WALLET_METADATA_SUCCESS,
    payload,
  }),
  getWalletMetaDataFail: (error) => ({
    type: actionTypes.GET_WALLET_METADATA_FAIL,
    error,
  }),
  getWalletTransactions: (params) => ({
    type: actionTypes.GET_WALLET_TRANSACTIONS_REQ,
    params,
  }),
  getWalletTransactionsSuccess: (payload, append = false) => ({
    type: actionTypes.GET_WALLET_TRANSACTIONS_SUCCESS,
    payload,
    append,
  }),
  getWalletTransactionsFail: (error) => ({
    type: actionTypes.GET_WALLET_TRANSACTIONS_FAIL,
    error,
  }),
  resetWalletTransactionsData: () => ({
    type: actionTypes.RESET_WALLET_TRANSACTIONS_DATA,
  }),
  setTransactionType: (value) => ({
    type: actionTypes.SET_TRANSACTION_TYPE,
    value,
  }),
  setModalApi: (value) => ({
    type: actionTypes.SET_MODAL_API,
    value,
  }),
  getModal: () => ({ type: actionTypes.GET_MODAL_REQ }),
  getModalSuccess: (payload) => ({
    type: actionTypes.GET_MODAL_SUCCESS,
    payload,
  }),
  getModalFail: (error) => ({
    type: actionTypes.GET_MODAL_FAIL,
    error,
  }),
  getDispute: (txn_id: string) => ({
    type: actionTypes.GET_DISPUTE,
    txn_id,
  }),
  getDisputeSuccess: (payload) => ({
    type: actionTypes.GET_DISPUTE_SUCCESS,
    payload,
  }),
  getDisputeFail: (error) => ({
    type: actionTypes.GET_DISPUTE_FAIL,
    error,
  }),

  setModalLoading: (value) => ({
    type: actionTypes.SET_MODAL_LOADING,
    value,
  }),
  resetFilters: () => ({
    type: actionTypes.RESET_FILTERS,
  }),
};

const walletReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_WALLET_SUMMARY_REQ:
      return {
        ...state,
      };
    case actionTypes.GET_WALLET_SUMMARY_SUCCESS:
      return {
        ...state,
        walletSummary: action.payload,
        error: null,
      };
    case actionTypes.GET_WALLET_SUMMARY_FAIL:
      return {
        ...state,
        walletSummary: null,
        error: action.error,
      };
    case actionTypes.SET_TIME_FILTER:
      return {
        ...state,
        currentTimeFilter: action.filter,
      };
    case actionTypes.SET_TRANSACTION_FILTER:
      return {
        ...state,
        currentTransactionFilter: action.filter,
      };
    case actionTypes.SET_WALLET_LOADING:
      return {
        ...state,
        isLoading: action.value,
      };
    case actionTypes.SET_WALLET_TXN_TYPE:
      return {
        ...state,
        walletTxnType: action.value,
      };
    case actionTypes.GET_WALLET_METADATA_REQ:
      return {
        ...state,
      };
    case actionTypes.GET_WALLET_METADATA_SUCCESS:
      return {
        ...state,
        timeFilters: action.payload?.TIME?.filters_list,
        transactionFilters: action.payload?.TRANSACTION?.filters_list,
      };
    case actionTypes.GET_WALLET_METADATA_FAIL:
      return {
        ...state,
        timeFilters: [],
        transactionFilters: [],
      };
    case actionTypes.GET_WALLET_TRANSACTIONS_REQ:
      return {
        ...state,
      };
    case actionTypes.GET_WALLET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        walletTransactions: {
          transactions: action.append
            ? [
                ...state.walletTransactions.transactions,
                ...action.payload.transactions,
              ]
            : action.payload.transactions,
          summary: action.payload.summary,
          hasMore: action.payload.hasMore,
          nextOffset: action.payload.nextOffset,
        },
      };
    case actionTypes.GET_WALLET_TRANSACTIONS_FAIL:
      return {
        ...state,
        walletTransactions: null,
      };
    case actionTypes.RESET_WALLET_TRANSACTIONS_DATA:
      return {
        ...state,
        walletTransactions: {
          transactions: [],
          summary: null,
          hasMore: true,
          nextOffset: 0,
        },
      };
    case actionTypes.SET_TRANSACTION_TYPE:
      return {
        ...state,
        transactionType: action.value,
      };
    case actionTypes.GET_DISPUTE:
      return {
        ...state,
      };
    case actionTypes.GET_DISPUTE_SUCCESS:
      return {
        ...state,
        dispute: action.payload,
      };
    case actionTypes.GET_DISPUTE_FAIL:
      return {
        ...state,
        dispute: null,
      };
    case actionTypes.SET_MODAL_API:
      return {
        ...state,
        modalApi: action.value,
      };
    case actionTypes.GET_MODAL_REQ:
      return {
        ...state,
      };
    case actionTypes.GET_MODAL_SUCCESS:
      return {
        ...state,
        modalData: action.payload,
      };
    case actionTypes.GET_MODAL_FAIL:
      return {
        ...state,
        modalData: null,
      };
    case actionTypes.SET_MODAL_LOADING:
      return {
        ...state,
        modalLoading: action.value,
      };
    case actionTypes.RESET_FILTERS:
      return {
        ...state,
        currentTimeFilter: {
          label: "Today",
          key: "TODAY",
        },
        currentTransactionFilter: {},
      };
    default:
      return state;
  }
};

walletReducer.initialState = initialState;
export default walletReducer;
